function formatMoney(cents) {
  if (!cents) return "$0";
  let value = (cents / 100).toFixed(0); 
  return "$" + value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      constructor() {
      super();
        this.quantityInput = this.querySelector(".quantity__input");
      }
      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }
      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }
      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }
      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }
      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        this.resetProductFormState();
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
        this.dataset.updateUrl === "true" && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }
      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }
      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
            html.querySelector("head title").innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }
      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }
        return `${url}?${params.join("&")}`;
      }
      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }
      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          let diamondShape = variant.option1;
          diamondShape = diamondShape.toLowerCase().replace(/ /g, "-");
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          if (!variant) {
            this.setUnavailable();
            return;
          }
          this.updateMedia(html, variant?.featured_media?.id);
          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };
          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
          const productDataEl = document.querySelector(`#ProductJson-${this.dataset.section}`);
          if (!productDataEl) return;
          let productData;
          try {
            productData = JSON.parse(productDataEl.textContent);
          } catch (e) {
            console.error("Invalid product JSON", e);
            return;
          }
          const variant = productData?.variants?.find(v => v.id == variantId);
          if (!variant) return;
          const addToCartBtn = document.querySelector(
            `#product-form-${this.dataset.section} [type="submit"] .price-area`
          );
          if (!addToCartBtn) return;
          const formatMoney = (cents) => {
            if (!cents) return "$0";
            let value = (cents / 100).toFixed(0); 
            return "$" + value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          };
          addToCartBtn.innerHTML = `<span class="add-to-cart-price">${formatMoney(variant.price)}</span>`;
        });
      }
      updateURL(url, variantId) {
        let collection = document.querySelector("[data-collection]")?.getAttribute("data-collection");      
        if (!collection) {
            const collectionMatch = window.location.pathname.match(/\/collections\/([^/]+)/);
            collection = collectionMatch ? collectionMatch[1] : null;
        }      
        if (!collection) {
            collection = '';
        }      
        const updatedUrl = `${window.shopUrl}/collections/${collection}${url}${variantId ? `?variant=${variantId}` : ''}`;      
        this.querySelector('share-button')?.updateUrl(updatedUrl);
        if (this.dataset.updateUrl === 'false') return;      
        window.history.replaceState({}, '', updatedUrl);
      }
      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );
        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }
      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        /**************** Add Klaviyo form trigger logic ****************/
        const klaviyoTrigger = this.querySelector('.klaviyo_form_trigger');
        if (klaviyoTrigger) {
          klaviyoTrigger.addEventListener('click', function () {
            window._klOnsite = window._klOnsite || [];
            if (window.innerWidth >= 768) {
              window._klOnsite.push(['openForm', 'XyGz4k']);
            } else {
              window._klOnsite.push(['openForm', 'SvVVUt']);
            }
          }, { once: true }); 
        }     
        /**************** ring size data section ****************/  
        const shapeInputs = document.querySelectorAll('input[name^="Diamond Shape"]');
        const diamondImages = document.querySelectorAll(".diamond-image img");
        const caratButtons = document.querySelectorAll('#caratButtons .carat-btn');
        const caratToScale = {
          1.0: 0.4,
          1.5: 0.475,
          2.0: 0.5,
          2.5: 0.575,
          3.0: 0.6,
          3.5: 0.675,
          4.0: 0.7,
          4.5: 0.715,
          5.0: 0.730,
        };  
        let currentCarat = 1.0;  
        caratButtons.forEach(btn => {
          btn.addEventListener('click', function () {
            caratButtons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');    
            currentCarat = parseFloat(this.dataset.carat);
            const activeDiamond = document.querySelector('.diamond-img.active');
            if (activeDiamond) {
              activeDiamond.style.transform = `scale(${caratToScale[currentCarat]})`;
            }
          });
        });
        shapeInputs.forEach(input => {
          input.addEventListener("change", function () {
            const selectedShape = this.value.toLowerCase();
            diamondImages.forEach(img => {
              img.classList.remove("active");
              img.style.transform = "";
            });
            const selectedImage = document.querySelector(`.${selectedShape}-img`);
            if (selectedImage) {
              selectedImage.classList.add("active");
              selectedImage.style.transform = `scale(${caratToScale[currentCarat]})`;
              selectedImage.style.transition = "transform 0.3s ease";
            }
          });
        });
        const defaultSelected = document.querySelector('input[name^="Diamond Shape"]:checked');
        if (defaultSelected) {
          defaultSelected.dispatchEvent(new Event('change'));
        }
        const activeCaratBtn = document.querySelector('.carat-btn.active');
        if (activeCaratBtn) {
          activeCaratBtn.click();
        }
        /**************** product wishlist ****************/  
        (function (Wishlist, $) {
          let $wishlistButtons = $('.wishlist-btn');
          let $wishlistRemoveButtons = $('.remove-wishlist');
          let $wishlistItemCount = $('.wishlist-item-count');
          let wishlist = localStorage.getItem('user_wishlist');
          wishlist = wishlist ? JSON.parse(wishlist) : [];
          function updateWishlistCount() {
            $wishlistItemCount.text(wishlist.length);
          }
          function animateWishlist(button) {
            $(button).toggleClass('included');
          }
          function updateWishlist(button) {
            let handle = $(button).attr('data-product-handle');
            let index = wishlist.indexOf(handle);
            if ($(button).hasClass('included')) {
              if (index > -1) wishlist.splice(index, 1);
            } else {
              if (index === -1) wishlist.push(handle);
            }
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
          }
          function activateIncludedButtons() {
            $wishlistButtons.each(function () {
              let handle = $(this).attr('data-product-handle');
              if (wishlist.indexOf(handle) > -1) {
                $(this).addClass('included');
              } else {
                $(this).removeClass('included');
              }
            });
          }
          function bindEvents() {
            $wishlistButtons.off('click').on('click', function (e) {
              e.preventDefault();
              updateWishlist(this);
              animateWishlist(this);
              updateWishlistCount();
            });
            $wishlistRemoveButtons.off('click').on('click', function (e) {
              e.preventDefault();
              let handle = $(this).attr('data-product-handle');
              let index = wishlist.indexOf(handle);
              if (index > -1) wishlist.splice(index, 1);
              localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
              updateWishlistCount();
              location.reload(); 
            });
          }
          Wishlist.init = function () {
            $wishlistButtons = $('.wishlist-btn');
            $wishlistRemoveButtons = $('.remove-wishlist');
            activateIncludedButtons();
            bindEvents();
            updateWishlistCount();
          };
        })(window.Wishlist = window.Wishlist || {}, jQuery);
        setTimeout(() => {
          Wishlist.init();
        }, 100);    
        /**************** product carat variant format ****************/
        const options = document.querySelectorAll('[data-selected-value]');
        document.querySelectorAll('.variant-option label').forEach(option => {
          option.addEventListener('click', function () {
            const newValue = option.getAttribute('title');
            const optionName = option.closest('fieldset').querySelector('.var-label').textContent.trim().split(':')[0];
            const targetSpans = Array.from(options).filter(span => span.getAttribute('data-option-name') === optionName);
            const targetIcon = document.querySelectorAll('.variant-icon[data-selected-value]');
            targetSpans.forEach(targetSpan => {
              if (optionName === 'Total Carat Weight') {
                if (newValue.includes('/')) {
                  const parts = newValue.split(' ');
                  if (parts.length === 2) {
                    const fraction = parts[1].split('/');
                    targetSpan.innerHTML = `${parts[0]} <sup>${fraction[0]}</sup>/<sub>${fraction[1]}</sub> ctw.`;
                  } else {
                    targetSpan.textContent = `${newValue} ctw.`;
                  }
                } else {
                  targetSpan.textContent = `${newValue} ctw.`;
                }
              } else if (optionName === 'Diamond Shape') {
                targetSpan.textContent = newValue;
                targetIcon.forEach(icon => {
                  icon.setAttribute('data-selected-value', newValue);
                });
              } else {
                targetSpan.textContent = newValue;
              }
            });
          });
        });
        /**************** product variant data for mobile view ****************/
          const mainVariants = document.querySelector('.main-variants');
          const variantDataItems = document.querySelectorAll('.variant-data');
          const closeButtons = document.querySelectorAll('.data-close');
          const dataSections = {
            'active-metal-data': document.querySelector('.metal-data'),
            'active-shape-data': document.querySelector('.shape-data'),
            'active-carat-data': document.querySelector('.carat-data')
          };
          if (!mainVariants || !variantDataItems.length) return;
          variantDataItems.forEach(item => {
            item.addEventListener('click', function(event) {
              event.stopPropagation();
              mainVariants.classList.add('active');
              document.body.classList.add('variant-open');
              Object.values(dataSections).forEach(section => {
                if (section) section.classList.remove('active');
              });
              mainVariants.classList.remove('open-metal', 'open-shape', 'open-carat');
              for (const [key, section] of Object.entries(dataSections)) {
                if (item.classList.contains(key) && section) {
                  section.classList.add('active');
                  if (key === 'active-metal-data') {
                    mainVariants.classList.add('open-metal');
                  } else if (key === 'active-shape-data') {
                    mainVariants.classList.add('open-shape');
                  } else if (key === 'active-carat-data') {
                    mainVariants.classList.add('open-carat');
                  }
                  break;
                }
              }
            });
          });
          closeButtons.forEach(button => {
            button.addEventListener('click', closeVariantSection);
          });
          document.body.addEventListener('click', function(event) {
            if (!mainVariants.contains(event.target)) {
              closeVariantSection();
            }
          });
          function closeVariantSection() {
            mainVariants.classList.remove('active');
            document.body.classList.remove('variant-open');        
            Object.values(dataSections).forEach(section => {
              if (section) section.classList.remove('active');
            });
            mainVariants.classList.remove('open-metal', 'open-shape', 'open-carat');
          }
        /**************** product image zoom ****************/
        let activeZoomImage = null;
        document.addEventListener("click", (e) => {
          if (!(e.target instanceof Element)) return;
          const image = e.target.closest(".zoom-image");
          if (!image) return;
          if (activeZoomImage === image) {
            disableZoom(image);
            activeZoomImage = null;
            return;
          }
          if (activeZoomImage) {
            disableZoom(activeZoomImage);
          }
          enableZoom(image);
          activeZoomImage = image;
        });
        document.addEventListener("mousemove", (e) => {
          if (!activeZoomImage) return;
          const rect = activeZoomImage.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          const xPercent = (x / rect.width) * 100;
          const yPercent = (y / rect.height) * 100;
          activeZoomImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
          activeZoomImage.style.transform = "scale(1.5)";
        });
        document.addEventListener("mouseleave", (e) => {
          if (!(e.target instanceof Element)) return; 
          if (!e.target.closest(".zoom-image") && activeZoomImage) {
            disableZoom(activeZoomImage);
            activeZoomImage = null;
          }
        });
        document.addEventListener("click", (e) => {
          if (!(e.target instanceof Element)) return; 
          if (!e.target.closest(".zoom-image") && activeZoomImage) {
            disableZoom(activeZoomImage);
            activeZoomImage = null;
          }
        });
        function enableZoom(image) {
          image.style.cursor = "zoom-out";
          image.style.transform = "scale(1.5)";
        }
        function disableZoom(image) {
          image.style.cursor = "zoom-in";
          image.style.transform = "scale(1)";
          image.style.transformOrigin = "center";
        }
        /**************** product video thumbnail ****************/
        const vimeoEl = document.querySelector("[vimeo-id]");
        if (vimeoEl) {
          const videoID = vimeoEl.getAttribute("vimeo-id");
          fetchVimeoThumbnail(videoID, "vimeo-thumbnail");
        }
        function fetchVimeoThumbnail(videoID, elementID) {
          const apiUrl = `https://vimeo.com/api/oembed.json?url=https%3A//player.vimeo.com/video/${videoID}`;
          fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
              let originalThumbnail = data.thumbnail_url;
              if (originalThumbnail) {
                let parts = originalThumbnail.split("_");
                if (parts.length > 1) {
                  parts[1] = "150x150"; 
                  let modifiedThumbnail = parts.join("_");
                  const imgEl = document.getElementById(elementID);
                  if (imgEl) {
                    imgEl.src = modifiedThumbnail;
                  }
                }
              }
            })
            .catch(error => console.error("Error fetching Vimeo data:", error));
        } 
        /**************** select current variant featch by the next clickable metal color  ****************/
        function getProductObject(handle) {
          return fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(product => {
              return product;
          })
          .catch(error => {
              console.error("Failed to fetch product:", error);
          });
        }
        function extractProductHandle(url) {
            let parts = url.split('/');
            let index = parts.indexOf("products");
            if (index !== -1 && parts.length > index + 1) {
                return parts[index + 1].split("?")[0];
            }
            return null;
        }
        function getCollectionNameFromUrl(url) {
            let pathParts = url.split('/');
            let index = pathParts.indexOf("collections");
            if (index !== -1 && pathParts.length > index + 1) {
                return pathParts[index + 1];
            }
            let currentParts = window.location.pathname.split('/');
            let currentIndex = currentParts.indexOf("collections");
            if (currentIndex !== -1 && currentParts.length > currentIndex + 1) {
                return currentParts[currentIndex + 1];
            }
            return "all";
        }                                            
        function redirectToMatchingVariant(handle, finalUrl, shape, carat) {
          getProductObject(handle).then(product => {
            if (!product || !product.variants) return;
            const matchedShape = product.variants.filter(variant =>
              variant.options[0].toLowerCase() === shape.toLowerCase()
            );
            const matchedVariant = matchedShape.find(variant =>
              variant.options[1].toLowerCase() === carat.toLowerCase()
            );
            if (matchedVariant) {
              console.log("Found Variant ID:", matchedVariant.id);
              window.location.href = `${finalUrl}?variant=${matchedVariant.id}`;
            } else {
              console.warn("No exact match found, redirecting to base product.");
              window.location.href = finalUrl;
            }
          });
        }    
        document.addEventListener("click", function (event) {
          const swatch = event.target.closest(".swatch-input__label a");
          if (!swatch) return;
          event.preventDefault();
          if (window.variantChangeTimeout) clearTimeout(window.variantChangeTimeout);
          window.variantChangeTimeout = setTimeout(() => {
            let baseUrl = swatch.getAttribute("data-url");
            let lastWord = swatch.getAttribute("data-last-word");
            if (!baseUrl || !lastWord) return;
            let newUrl = baseUrl.match(/-\w+$/)
            ? baseUrl.replace(/-\w+$/, `-${lastWord}`)
            : `${baseUrl}-${lastWord}`;
            let collectionName = window.currentCollectionHandle || '';
            let finalUrl = collectionName
            ? `/collections/${collectionName}${newUrl}`
            : newUrl;
            let productHandle = extractProductHandle(finalUrl);
            let shape = document.querySelector(".normal-variant-selected-value.diamond-shape")?.textContent.trim();
            let carat = document.querySelector(".variant-selected-value.total-carat-weight")?.textContent.trim();
            redirectToMatchingVariant(productHandle, finalUrl, shape, carat);
          }, 200);
        });
        /**************** select current variant current title changes  ****************/
        const metalswatches = document.querySelectorAll(".swatch");
        const metalselectedValueElement = document.querySelector(
          ".metal-label .selected-value"
        );
        const swatchTitleMapping = {
          "14WG": "14K White Gold",
          "14YG": "14K Yellow Gold",
          "14RG": "14K Rose Gold",
          "18WG": "18K White Gold",
          "18YG": "18K Yellow Gold",
          "18RG": "18K Rose Gold",
            PL: "Platinum",
        };
        function getSwatchFullName(title) {
          const parts = title.split("-");
          const code = parts[1];
          return swatchTitleMapping[code] || code;
        }
        function setActiveSwatchValue() {
          const activeSwatch = document.querySelector(
            ".swatch-input__label.active .swatch"
          );
          if (activeSwatch && metalselectedValueElement) {
            const activeTitle = activeSwatch.getAttribute("data-swatch-title");
            const fullTitle = getSwatchFullName(activeTitle);
            metalselectedValueElement.textContent = fullTitle;
          }
        }
        setActiveSwatchValue();
        metalswatches.forEach(function (swatch) {
          swatch.addEventListener("mouseover", function () {
            const swatchTitle = swatch.getAttribute("data-swatch-title");
            const fullTitle = getSwatchFullName(swatchTitle);
            if (metalselectedValueElement) {
              metalselectedValueElement.textContent = fullTitle;
            }
          });
          swatch.addEventListener("mouseout", function () {
            setActiveSwatchValue();
          });
        });
        const fieldset = document.querySelector(".product-form__input--swatch");
        if (fieldset) {
          const observer = new MutationObserver(() => {
            setActiveSwatchValue();
          });
          observer.observe(fieldset, { childList: true, subtree: true });
        }
        const diamondShapeLabels = document.querySelectorAll(
          ".variant-swatches.diamond-shape"
        );
        const diamondShapeSelectedValueSpan = document.querySelector(
          ".normal-variant-selected-value.diamond-shape"
        );
        function updateDiamondShapeValue(value) {
          diamondShapeSelectedValueSpan.textContent = value;
        }
        function resetNormalSelectedValue() {
          const checkedValue = document.querySelector(
            ".variant-pills:checked"
          ).value;
          diamondShapeSelectedValueSpan.textContent = checkedValue;
        }
        diamondShapeLabels.forEach((label) => {
          label.addEventListener("mouseenter", function () {
            const newValue = label.getAttribute("title"); 
            updateDiamondShapeValue(newValue);
          });
          label.addEventListener("mouseleave", function () {
            const checkedValue = document.querySelector(
              ".diamond-pills:checked"
            ).value;
            if (checkedValue) {
              updateDiamondShapeValue(checkedValue);
            }
          });
          label.addEventListener("click", function () {
            const selectedValue = label.getAttribute("title");
            updateDiamondShapeValue(selectedValue);
            resetNormalSelectedValue();
          });
        });
        const caratWeightLabels = document.querySelectorAll(
          ".variant-swatches.total-carat-weight"
        );
        const caratWeightSelectedValueSpan = document.querySelector(
          ".variant-selected-value.total-carat-weight"
        );
        function formatFractionValue(value) {
          const mixedFractionMatch = value.match(/^(\d+)\s(\d+)\/(\d+)$/);
          if (mixedFractionMatch) {
            return `${mixedFractionMatch[1]} <sup>${mixedFractionMatch[2]}</sup>/<sub>${mixedFractionMatch[3]}</sub>`;
          }
          const simpleFractionMatch = value.match(/^(\d+)\/(\d+)$/);
          if (simpleFractionMatch) {
            return `<sup>${simpleFractionMatch[1]}</sup>/<sub>${simpleFractionMatch[2]}</sub>`;
          }
          return value;
        }
        function updateCaratWeightValue(value) {
          const formattedValue = formatFractionValue(value);
          caratWeightSelectedValueSpan.innerHTML = formattedValue;
        }
        caratWeightLabels.forEach((label) => {
          label.addEventListener("mouseenter", function () {
            const newValue = label.getAttribute("title");
            updateCaratWeightValue(newValue);
          });
          label.addEventListener("mouseleave", function () {
            const checkedValue = document.querySelector(
              ".carat-pills:checked"
            ).value;
            if (checkedValue) {
              updateCaratWeightValue(checkedValue);
            }
          });
          label.addEventListener("click", function () {
            const selectedValue = label.getAttribute("title");
            updateCaratWeightValue(selectedValue);
          });
        });
        /**************** product images  ****************/
        if (this.querySelector("media-gallery")?.getAttribute("has_variant") === "true") {
          const mediaGallerySource = this.querySelector("media-gallery");
          const mediaGalleryDestination = html.querySelector("media-gallery");
          mediaGallerySource.outerHTML = mediaGalleryDestination.outerHTML;
          if (document.querySelector(".mySwiper")) {
            const mySwiper = new Swiper(".mySwiper", {
              loop: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              slidesPerView: 1,
              spaceBetween: 10,
              breakpoints: {
                320: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 1 },
              },
            });
            window.swiperInstances = [mySwiper];
          }  
          return;
        }
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector("media-gallery ul");    
        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };
        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );    
          let shouldRefresh = false;  
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }
          if (shouldRefresh)
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();  
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );  
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
        modalContent.innerHTML = newModalContent.innerHTML;
        if (document.querySelector(".mySwiper")) {
          const mySwiper = new Swiper(".mySwiper", {
            loop: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
              320: { slidesPerView: 1 },
              768: { slidesPerView: 1 },
              1024: { slidesPerView: 1 },
            },
          });         
          window.swiperInstances = [mySwiper];
        }
      }
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };
        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.quantityInput.min = min;
        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden");
        fetch( `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }
      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      get productForm() {
        return this.querySelector(`product-form`);
      }
      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }
      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }
      get variantSelectors() {
        return this.querySelector("variant-selects");
      }
      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }
      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}